<script>
import "@/assets/css/page.css"

export default {
  data() {
    return {
      banners: [
        require("@/assets/uploads/product/product-1.png"),
        require("@/assets/uploads/product/product-2.png"),
        require("@/assets/uploads/product/product-3.png"),
        require("@/assets/uploads/product/product-4.png"),
        require("@/assets/uploads/product/product-5.png"),
        require("@/assets/uploads/product/product-6.png"),
        require("@/assets/uploads/product/product-7.png"),
        require("@/assets/uploads/product/product-8.png"),
        require("@/assets/uploads/product/product-9.png"),
        require("@/assets/uploads/product/product-10.png"),
        require("@/assets/uploads/product/product-11.png"),
        require("@/assets/uploads/product/product-12.png"),
        require("@/assets/uploads/product/product-13.png"),
        require("@/assets/uploads/product/product-14.png"),
        require("@/assets/uploads/product/product-15.png"),
        require("@/assets/uploads/product/product-16.png"),
        require("@/assets/uploads/product/product-17.png"),
        require("@/assets/uploads/product/product-18.png"),
        require("@/assets/uploads/product/product-19.png"),
        require("@/assets/uploads/product/product-20.png"),
        require("@/assets/uploads/product/product-21.png"),
        require("@/assets/uploads/product/product-22.png"),
      ]
    }
  },
}

</script>

<template>
  <div id="main_body">
    <header class="main_header">
      <div class="header-wrapper">
        <div class="inner">
          <img src="@/assets/uploads/products.jpg" class="attachment-full size-full">
        </div>
      </div>
    </header>

    <div>&nbsp;</div>

    <div class="npagePage ff_pageList">
      <div class="content">
        <div class="mlist service module ff_noSlider" style="">
          <div class="mlist imagelink module ff_noSlider" style="">

            <div class="bgmask"></div>
            <div class="module_container">
              <div class="container_content nocat">
                <div class="content_wrapper">
                  <ul class="content_list">
                    <div v-for="b in banners">
                    <li id="item_blo" class="item_block wow" style="animation-delay: 0s; visibility: visible; animation-name: fadeInUp;">
                      <div class="item_box" target="_blank">
                        <img :src="b">
                      </div>
                    </li>
                    </div>

                  </ul>
                </div>

                <div class="clear"></div>

                <div id="pages">
                  <nav aria-label="page navigation" class="my-4">
                    <div class="pagination justify-content-center">
                      <a class="page-item page-link" href="/products_9.html">首页</a>
                      <a class="page-item page-link" href="javascript:;">上一页</a>
                      <a href="/" class="page-num page-num-current">1</a>
                      <a class="page-item page-link" href="/products_9_2.html">下一页</a>
                      <a class="page-item page-link" href="/products_9_4.html">尾页</a>
                    </div>
                  </nav>

                </div>

              </div>

              <div class="clear"></div>

            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<style scoped>

</style>